import {createSelector} from 'reselect';

const EMPTY_ARRAY: any[] = [];
const EMPTY_OBJECT = {};

const selectLeadsState = (state: DefaultRootState) => state?.leads;
const selectLeadSourcesState = (state: DefaultRootState) => state?.leadSources;


export const selectLeads = createSelector(
  [selectLeadsState],
  (leads) => leads?.list || {}
)

export const selectGroupedLeads = createSelector(
  [selectLeadsState],
  (leads) => leads?.groupedList || {}
)

export const selectTableData = createSelector(
  [selectLeadsState],
  (leads) => leads?.tableData || {}
)

export const selectFieldChangeLoading = createSelector(
  [selectLeadsState],
  (leads) => leads?.changeLoadings || {}
)

export const selectAllAgentsList = createSelector(
  [selectLeadsState],
  (leads) => leads?.allAgentsList || EMPTY_ARRAY
)

export const selectAssignableAgentsList = createSelector(
  [selectLeadsState],
  (leads) => leads?.assignableAgentsList || EMPTY_ARRAY
)

export const selectActiveAgentsList = createSelector(
  [selectLeadsState],
  (leads) => leads?.activeAgentsList || EMPTY_ARRAY
)

export const selectAgentsInitialized = createSelector(
  [selectLeadsState],
  (leads) => leads?.agentsInitialized
)

export const selectUnassignedLeads = createSelector(
  [selectLeadsState],
  (leads) => leads?.unassignedLeadsList || {}
)
export const selectAssignmentDrawerVisible = createSelector(
  [selectLeadsState],
  (leads) => leads?.assignmentDrawerVisible
);

export const selectAddLeadDrawer = createSelector(
  [selectLeadsState],
  (leads) => leads?.addLead?.drawer
)

export const selectLeadDetailsDrawer = createSelector(
  [selectLeadsState],
  (leads) => leads?.leadDetailsDrawer
)
export const selectProjectTasks = createSelector(
  [selectLeadsState, (_, leadId) => leadId],
  (leads, leadId) => leads?.projectTasks?.[leadId]
)
export const selectLeadDetails = createSelector(
  [selectLeadsState, (_, leadId) => leadId],
  (leads, leadId) => leads?.details?.[leadId]
)
export const selectArchiveLoading = createSelector(
  [selectLeadsState, (_, leadId) => leadId],
  (leads, leadId) => leads?.archiveLoading?.[leadId]
);

export const selectIsLeadArchived = createSelector(
  [selectLeadsState, (_, leadId) => leadId],
  (leads, leadId) => leads?.archivedLeads?.[leadId]
);

export const selectAllLeadsData = createSelector(
  [selectLeadsState],
  (leads) => leads?.leads || {}
)

export const selectLeadData = createSelector(
  [selectLeadsState, (_, leadId) => leadId],
  (leads, leadId) => leads?.leads?.[leadId]
)

// Whatever this client currently holds for the lead: the list entry, else the drawer entry.
export const selectLeadInStore = createSelector(
  [selectLeadsState, (_, leadId) => leadId],
  (leads, leadId) => leads?.leads?.[leadId] || leads?.details?.[leadId]
)

export const selectRecentLocalEdit = createSelector(
  [selectLeadsState, (_, leadId) => leadId],
  (leads, leadId) => leads?.recentLocalEdits?.[leadId]
)

export const selectLeadFields = createSelector(
  [selectLeadSourcesState],
  (leadSources) => leadSources?.leadFields || { default: [], meta: [] }
)

export const selectColdProspectsOverview = createSelector(
  [selectLeadsState],
  (leads) => leads?.coldProspectsOverview || {}
)

export const selectKanbanItems = createSelector(
  [selectLeadsState],
  (leads) => leads?.kanbanItems || []
)

export const selectKanbanItemsColumnsIncrements = createSelector(
  [selectLeadsState],
  (leads) => leads?.kanbanItemsColumnsIncrements || []
)
export const selectGroupedLeadsUpdatedAt = createSelector(
  [selectLeadsState],
  (leads) => leads?.groupedList?.updatedAt
);

export const selectLeadsMagicFieldEditor = (state: DefaultRootState) => state?.leads?.magicFieldEditor
